import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';

@Injectable()
export class DragDropImageService {
  private readonly conf = inject(CoreAuthConfigService);
  constructor(private readonly httpClient: HttpClient) {}
  API_ENDPOINTs = {
    UPLOAD: this.conf.buildFileV2URL('/upload'),
    DOWNLOAD: this.conf.buildFileV2URL('/get-list'),
  };

  loadImage(fileV2: any) {
    const url = this.API_ENDPOINTs.DOWNLOAD;

    return this.httpClient.post<Array<any>>(url, {
      list_server_file_name: [fileV2.server_file_name],
    });
  }

  upload = (blob: Blob) => {
    const originalFileName = 'avatar.png';
    const serverFolderName = '';
    const fileExtension = originalFileName.split('.').pop();

    const formData = new FormData();
    formData.append('type', 'image');
    formData.append('folder_type', serverFolderName);
    formData.append('files', blob, originalFileName);
    formData.append('ext', fileExtension ?? '');

    return this.httpClient
      .post(this.API_ENDPOINTs.UPLOAD, formData, {
        headers: {
          use_appkey: "true",
        }
      })
      .pipe(map((e: any) => e['files'][0]));
  };

  download(serverFileName: string) {
    const requestBody = {
      list_server_file_name: [serverFileName],
    };
    return this.httpClient.post(this.API_ENDPOINTs.DOWNLOAD, requestBody, {
      responseType: 'blob',
    });
  }
}
